import styled from 'styled-components'

const Description = styled.p`
    margin: 0 0 1em;
    line-height: 1.3125rem;
    font-size: 0.94rem;
`

export default Description
